import { Link as RouterLink, useLocation } from 'react-router-dom';

import { landingLink } from '@/app/navigation';
import { ROLE_LABELS } from '@/auth/roles';
import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/ui/Button';
import { stateText } from '@/lib/routerState';

import { StatusPage } from './StatusPage';

/** Shown when the role guard blocks a route. */
export function ForbiddenPage() {
  const { user } = useAuth();
  const location = useLocation();
  const from = stateText(location.state, 'from');
  const back = landingLink(user?.role);

  return (
    <StatusPage
      title="You do not have access to that page"
      documentTitle="No access"
      address={from}
      testId="forbidden"
      action={
        <Button
          component={RouterLink}
          to={back.to}
          variant="secondary"
          data-testid="forbidden-back-link"
        >
          {back.label}
        </Button>
      }
    >
      {from ? 'needs a different role. ' : null}
      You are currently acting as{' '}
      <strong data-testid="forbidden-role-value">
        {user ? ROLE_LABELS[user.role] : 'nobody'}
      </strong>
      .
    </StatusPage>
  );
}
